<script>
import { BModal, VBTooltip } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  data: () => ({
    link: '',
    page: {
      metadata: {
        name: '',
      },
    },
    pages: null,
    leadgenForms: {},
    selectedForms: {},
  }),

  created() {
    this.fetch();
    this.getLink();
  },

  methods: {
    fetch() {
      this.$http.get('/integration/facebook-pages').then(({ data }) => {
        this.pages = data;
        return data;
      });
    },

    getLink() {
      this.$http.get('/integration/facebook-link').then(({ data }) => {
        this.link = data;
      });
    },

    listForms(page) {
      this.page = page;

      this.$http
        .get(`/integration/facebook/page/${page.id}`)
        .then(({ data: { selected, leadgenForms } }) => {
          this.leadgenForms = leadgenForms;
          this.selectedForms = selected;

          this.$refs['modal-facebook-leadgen-list'].show();
        })
        .catch(() => {
          Alert.error(
            'Erro ao listar formulários, tente novamente mais tarde.',
          );
        });
    },

    send() {
      this.$http
        .post(`/integration/facebook/page/${this.page.id}/subscribe`, {
          leadgenForms: this.selectedForms,
        })
        .then(() => {
          this.fetch();
          this.hideModal();
        });
    },

    unsubscribe(page, index) {
      this.$http
        .delete(`/integration/facebook/page/unsubscribe/${page.id}`)
        .then(() => {
          this.$delete(this.pages, index);
        });
    },

    hideModal() {
      this.$refs['modal-facebook-leadgen-list'].hide();
    },

    getObjectLength(object = {}) {
      return Object.keys(object).length;
    },

    toggle(name, key) {
      if (this.selectedForms[key]) {
        return Vue.delete(this.selectedForms, key);
      }

      if (!this.getObjectLength(this.selectedForms)) {
        this.selectedForms = {};
      }

      Vue.set(this.selectedForms, key, name);
    },

    toggleAll() {
      if (this.getObjectLength(this.selectedForms)) {
        this.selectedForms = {};
        return {};
      }

      this.selectedForms = { ...this.leadgenForms };
    },
  },
};
</script>

<template>
  <section class="w-100">
    <div class="row mt-3 with-shadow">
      <div v-if="pages" class="pages w-100">
        <table class="table table-striped table-borderless with-shadow">
          <thead>
            <tr>
              <th class="pl-30px">Página</th>

              <th v-text="__('Formulários inscritos')" />

              <th />
            </tr>
          </thead>

          <tbody v-if="pages.length">
            <tr :key="page.id" v-for="(page, index) in pages">
              <td class="pl-30px" v-text="page.metadata.name" />

              <td v-text="getObjectLength(page.metadata.leadgenForms)" />

              <td class="d-flex align-items-center pr-30px">
                <a
                  href="#"
                  class="ml-auto mt-n1px"
                  @click="listForms(page)"
                  v-b-tooltip.left="__('Listar formulários')"
                >
                  <IconPencilFilled :size="18" />
                </a>

                <a
                  href="#"
                  class="ml-4 mt-n1px"
                  @click="unsubscribe(page, index)"
                  v-b-tooltip.left="__('Desinscrever')"
                >
                  <IconTrash :size="18" />
                </a>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr class="empty">
              <td class="pl-30px">
                {{ __('Nenhum registro encontrado') }}

                <br />

                <small class="small-text">
                  {{ __('Clique em') }}

                  <a :href="link" v-text="__('Integrar páginas')" />

                  {{ __('para atualizar essa listagem') }}.
                </small>
              </td>

              <td />
              <td />
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row bdk-mt-4">
      <div class="col-12 d-flex align-items-center bdk-ml-auto">
        <a :href="link" class="ml-auto btn btn-green">
          <span class="link-label" v-text="__('Integrar Páginas')" />
        </a>
      </div>
    </div>

    <BModal
      size="xl"
      hide-header="hide-header"
      hide-footer="hide-footer"
      id="modal-facebook-leadgen-list"
      ref="modal-facebook-leadgen-list"
      modal-class="modal-no-header-no-footer"
    >
      <template slot="default">
        <button
          class="close"
          type="button"
          aria-label="Close"
          @click="hideModal()"
        >
          <span aria-hidden="true">×</span>
        </button>

        <h4 class="modal-title align-items-center text-center mb-0">
          {{ __('Formulários da página') }}

          <strong v-text="page.metadata.name" />
        </h4>

        <div class="px-20px">
          <p
            class="form-text mt-20px"
            v-text="__('Selecione os formulários que deseja integrar')"
          />

          <table class="table table-striped table-borderless with-shadow">
            <thead>
              <tr>
                <th class="pl-30px">
                  {{ __('Formulário') }}
                </th>

                <th class="pr-30px">
                  <div
                    @click="toggleAll()"
                    class="toggle ml-auto"
                    v-if="getObjectLength(leadgenForms)"
                    :class="{
                      selected:
                        getObjectLength(leadgenForms) ===
                        getObjectLength(selectedForms),
                    }"
                  />
                </th>
              </tr>
            </thead>

            <tbody v-if="getObjectLength(leadgenForms)">
              <tr :key="key" v-for="(name, key) in leadgenForms">
                <td v-text="name" class="pl-30px" />

                <th class="pr-30px">
                  <div
                    class="toggle ml-auto"
                    @click="toggle(name, key)"
                    :class="{ selected: selectedForms[key] }"
                  />
                </th>
              </tr>
            </tbody>

            <tbody v-else>
              <tr class="empty">
                <td
                  class="pl-30px"
                  v-text="__('Não consta formulários para esta página')"
                />

                <td />
              </tr>
            </tbody>
          </table>

          <div class="modal-footer default-modal-footer">
            <div class="ml-auto text-right">
              <button
                type="button"
                @click="send()"
                class="btn btn-primary ml-3 mb-2"
                :disabled="!getObjectLength(selectedForms)"
                v-text="__('Integrar formulários selecionados')"
              />
            </div>
          </div>
        </div>
      </template>
    </BModal>
  </section>
</template>

<style lang="scss" scoped>
@import '../../../sass/variables';

.link-white {
  color: $white;
}

.link-label {
  color: $white;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1rem;
}

.toggle {
  width: 1.25rem;
  height: 1.25rem;
  position: relative;
  cursor: pointer;

  &:hover:before {
    border: 1px solid $green !important;
  }
}

.toggle:before,
.selected:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 1.25rem;
  height: 1.25rem;
  border: 1px solid $gray;
  border-radius: 3px;
}

.toggle:after,
.selected:after {
  content: '\2713';
  position: absolute;
  left: 0.125rem;
  top: 0.125rem;
  font-size: 1.3rem;
  line-height: 0.8;
  color: $green;
  transition: all 0.2s;
}

.toggle:not(.selected):after {
  opacity: 0;
  transform: scale(0);
}

.toggle.selected:after {
  opacity: 1;
  transform: scale(1);
}

.btn-light,
.btn-light:not(:disabled):not(.disabled):active,
.btn-light:not(:disabled):not(.disabled).active {
  color: $gray-dark;
  background-color: $gray-white;
}

.btn-light:hover {
  background-color: $gray-white-2;
}
</style>
